import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Translate, { TranslateProps } from 'client/components/translate';

const propTypes = {
  benefit: PropTypes.object,
  label: TranslateProps.isRequired,
  description: TranslateProps,
  value: TranslateProps,
};

const defaultProps = {
  benefit: {},
  description: null,
  value: null,
};

export default class VisionListItem extends PureComponent {
  render() {
    const { benefit, label, description, value } = this.props;
    const hasAdditionalSavings = !description && !!benefit.amountSavings;

    return (
      <div className="detail-list-item">
        <div className="flex-row end detail-item">
          <div className="name" style={{ overflow: 'hidden' }}>
            <div><Translate {...label} /></div>
            {description && (
              <div className="description">
                <Translate {...description} />
              </div>
            )}
            {hasAdditionalSavings && (
              <div className="description">
                <Translate path="vision.planDetails.savingsAfterAllowance" using={benefit} />
              </div>
            )}
          </div>
          <div className="flex-child-expand-no-shrink right value">
            {!value ?
              `${benefit.value}${hasAdditionalSavings || benefit.disclaimer ? '*' : ''}`:
              <Translate {...value} />
            }
          </div>
        </div>
      </div>
    );
  }
}

VisionListItem.propTypes = propTypes;
VisionListItem.defaultProps = defaultProps;
